module.exports = {"data":{"markdownRemark":{"html":"<p>We solve [your] problems with technology.</p>","frontmatter":{"title":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/about/index.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 352
// module chunks = 273950069227526